<template>
  <pagefra>
    <div class="role fullscreen container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form :inline="true" v-model="form" class="toolbar-form">
            <el-form-item :label="$l('角色名称')">
              <el-input
                v-model="form.roleName"
                maxlength="30"
                :placeholder="$l('角色名称')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd()"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <!-- <el-button icon="el-icon-refresh-right" round>重置</el-button> -->
            <el-button
              icon="el-icon-delete"
              round
              @click="deleteRole"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="roleName"
              :label="$l('角色名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="creator"
              :label="$l('创建者')"
              min-width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="createDate"
              :label="$l('创建时间')"
              min-width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="remark"
              :label="$l('备注')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              :label="$l('设置权限')"
              min-width="80"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('设置权限')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="$store.state.user.roleId != scope.row.roleId"
                  @click.native.prevent="showPermissions(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('设置字段权限')"
              min-width="120"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('设置字段权限')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showFieldPermissions(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('设置首页权限')"
              min-width="120"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="$store.state.user.roleType == 1"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showIndexPermissions(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('设置故障内容权限')"
              min-width="130"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('设置故障内容权限')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showDictionaryPermissions(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
                <!-- <el-button type="primary" clear icon="el-icon-delete">
              </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        @closed="closeEditDialog"
        width="640px"
      >
        <!-- <el-dialog :title="editDialogTitle" visible="true" @closed="closeEditDialog" width="1200px"> -->
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('角色名称')" prop="roleName">
            <el-input v-model="editForm.roleName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('备注')" prop="remark">
            <el-input type="textarea" v-model="editForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('设置权限')"
        :visible.sync="treeDialogVisible"
        width="30%"
      >
        <el-tree
          ref="tree"
          :data="permissions"
          show-checkbox
          node-key="id"
          :props="treeProps"
          :default-expanded-keys="expandedKeys"
        ></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="treeDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="setRolePermission"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$l('设置字段权限')"
        :visible.sync="fieldTreeDialogVisible"
        width="30%"
        @close="fieldTreeDialogClose"
      >
        <el-tree
          ref="fieldTree"
          :data="fieldPermissions"
          show-checkbox
          node-key="id"
          :props="fieldTreeProps"
          :default-expanded-keys="expandedKeys"
        ></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="fieldTreeDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="setRoleFieldPermission"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$l('设置首页权限')"
        :visible.sync="indexDialogVisible"
        width="30%"
        @close="indexDialogClose"
      >
        <div class="inputfra">
          <el-checkbox-group v-model="checkIndexPermissions">
            <el-checkbox
              v-for="(item, i) in indexPermissions"
              :label="$l(item)"
              :key="i"
              >{{ item }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="indexDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="setIndexPermission"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('设置故障内容权限')"
        :visible.sync="dictionaryDialogVisible"
        width="30%"
        @close="dictionaryDialogClose"
      >
        <div class="inputfra">
          <el-checkbox-group v-model="checkDictionaryPermissions">
            <el-checkbox
              v-for="(item, i) in dictionaryPermissions"
              :label="item.id"
              :key="i"
              >{{ $l(item.name) }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="dictionaryDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="setDictionaryPermission"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
// import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
// import { performance } from 'perf_hooks';

export default {
  name: "role",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateRoleName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入角色名称")));
      } else {
        callback();
      }
    };
    return {
      form: {
        roleName: "",
      },
      roleList: [],
      permissions: [],
      fieldTreeProps: {
        children: "children",
        label: "name",
      },
      fieldPermissions: [],
      treeProps: {
        children: "children",
        label: "name",
      },
      editDialogVisible: false,
      treeDialogVisible: false,
      fieldTreeDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        roleId: null,
        roleName: "",
        oldRoleName: "",
        userIds: null,
        remark: "",
        permissionIdList: [],
        oldPermissionIdList: [],
      },
      curRole: {
        roleId: null,
        userId: null,
        userIds: null,
        permissionIdList: [],
        oldPermissionIdList: [],
        oldFieldIdList: [],
      },
      rules: {
        roleName: [
          {
            required: true,
            message: this.$l("请输入角色名称"),
            trigger: "blur",
          },
          {
            max: 30,
            message: this.$l("长度不能超过 30 个字符"),
            trigger: "blur",
          },
          { validator: validateRoleName, trigger: "blur" },
        ],
        remark: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
      },
      editInputVisible: false,
      editInputValue: "",
      tableData: null,
      loading: false,
      selectedList: [],
      expandedKeys: [],
      indexDialogVisible: false,
      checkIndexPermissions: [],
      indexPermissions: [
        "今日救援进度统计",
        "无纸化保养记录",
        "运行次数分布",
        "遥监设备状态",
        "今日实时关注信息",
        "梯龄分布",
        "年检提醒",
        "合同提醒",
        "昨日遥监预警记录汇总",
      ],
      dictionaryDialogVisible: false,
      checkDictionaryPermissions: [],
      dictionaryPermissions: [],
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    loadPermissions(fn) {
      this.$http
        .get(this.$apiConfig.get_role_permissionTree_url, {
          params: {
            userId: this.curRole.userId,
          },
        })
        .then((response) => {
          let data = response.data;
          if (data.code == 0) {
            this.permissionTree = data.data;
            this.permissions = data.data;
            if (fn) {
              fn();
            }
          } else {
            this.message(data.code, data.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showAdd() {
      this.editDialogTitle = "新建角色";
      this.editDialogVisible = true;
      this.editForm.roleId = null;
    },
    showEdit(row) {
      this.editDialogTitle = "编辑角色";
      this.editDialogVisible = true;
      this.$http
        .get(this.$apiConfig.get_role_url + row.roleId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = result.data[key];
            }
            this.editForm.oldRoleName = this.editForm.roleName;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showPermissions(row) {
      this.treeDialogVisible = true;
      let roleId = row.roleId;
      if (this.curRole.roleId == roleId) {
        return;
      }
      this.curRole.roleId = roleId;
      this.curRole.userId = row.userId;
      this.curRole.roleName = row.roleName;
      this.curRole.userIds = row.userIds;
      this.loadPermissions(() => {
        this.$http
          .get(this.$apiConfig.get_role_permission_url + "/" + roleId)
          .then((response) => {
            let result = response.data;
            if (result.code == 0) {
              let data = result.data;
              this.curRole.oldPermissionIdList = data;
              let oldPermissionIdList = this.curRole.oldPermissionIdList;
              this.expandedKeys = oldPermissionIdList;
              this.$refs.tree.setCheckedKeys(data);
              let selectedKeys = this.$refs.tree.getCheckedKeys();
              selectedKeys.forEach((item, index) => {
                let flag = false;
                if (oldPermissionIdList.filter((n) => n == item).length == 0) {
                  this.$refs.tree.setChecked(item, false);
                }
              });
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      });
    },
    showFieldPermissions(row) {
      this.fieldTreeDialogVisible = true;
      this.curRole.roleId = row.roleId;
      this.curRole.userIds = row.userIds;
      this.fieldPermissions = [];
      let tempFieldPermissions = JSON.parse(JSON.stringify(window.fieldData));
      this.$http
        .get(this.$apiConfig.get_role_field_permission_url + row.roleId)
        .then((response) => {
          this.$refs.fieldTree.setCheckedKeys([]);
          let result = response.data;
          if (result.code == 0) {
            let datas = result.data;
            let keys = [];
            datas.forEach((item, index) => {
              keys.push(item.id);
            });
            this.curRole.oldFieldIdList = keys;
            if (
              this.$store.state.user.roleType > 1 ||
              this.$store.state.user.userId != row.userId
            ) {
              this.$http
                .get(
                  this.$apiConfig.get_parent_role_field_permission_url +
                    row.userId
                )
                .then((response) => {
                  result = response.data;
                  if (result.code == 0) {
                    datas = result.data;
                    let indexArr = [];
                    let n = 0;
                    tempFieldPermissions.forEach((item1, i) => {
                      let tempArr1 = [];
                      let indexArr2 = [];
                      item1.children.forEach((item2, j) => {
                        if (item2.children) {
                          let tempArr2 = [];
                          item2.children.forEach((item3, z) => {
                            if (
                              datas.filter((t) => t.id == item3.id).length == 1
                            ) {
                              tempArr2.push(item3);
                            }
                          });
                          if (tempArr2.length == 0) {
                            indexArr2.push(j);
                          } else {
                            item2.children = tempArr2;
                          }
                        } else {
                          if (
                            datas.filter((t) => t.id == item2.id).length == 1
                          ) {
                            tempArr1.push(item2);
                          }
                        }
                      });
                      if (indexArr2.length > 0) {
                        if (item1.children.length == indexArr2.length) {
                          indexArr.push(i);
                        }
                        indexArr2.forEach((ii, iii) => {
                          item1.children.splice(ii - n, 1);
                          n++;
                        });
                      } else {
                        if (tempArr1.length == 0) {
                          indexArr.push(i);
                        } else {
                          item1.children = tempArr1;
                        }
                      }
                    });
                    n = 0;
                    indexArr.forEach((i, ii) => {
                      tempFieldPermissions.splice(i - n, 1);
                      n++;
                    });
                    this.fieldPermissions = tempFieldPermissions;
                    this.$refs.fieldTree.setCheckedKeys(keys);
                  }
                })
                .catch((error) => {
                  this.$refs.fieldTree.setCheckedKeys([]);
                  this.errorMessage();
                  this.$sentry.captureException(error);
                });
            } else {
              this.fieldPermissions = tempFieldPermissions;
              this.$refs.fieldTree.setCheckedKeys(keys);
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.$refs.fieldTree.setCheckedKeys([]);
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showIndexPermissions(row) {
      this.indexDialogVisible = true;
      this.curRole.roleId = row.roleId;
      this.checkIndexPermissions = [];
      this.$http
        .get(this.$apiConfig.get_role_index_permission_url + row.roleId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.checkIndexPermissions = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    setIndexPermission() {
      this.$http
        .post(this.$apiConfig.set_role_index_permission_url, {
          roleId: this.curRole.roleId,
          permissionList: this.checkIndexPermissions,
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.indexDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    showDictionaryPermissions(row) {
      this.dictionaryDialogVisible = true;
      this.curRole.roleId = row.roleId;
      this.checkDictionaryPermissions = [];
      this.dictionaryPermissions = JSON.parse(
        JSON.stringify(window.dataDictionary)
      );
      this.$http
        .get(this.$apiConfig.get_role_dictionary_permission_url + row.roleId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.checkDictionaryPermissions = result.data.map((t) => t.id);
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    setDictionaryPermission() {
      let list = this.dictionaryPermissions.filter(
        (t) =>
          this.checkDictionaryPermissions.filter((t2) => t2 == t.id).length == 1
      );
      let permissionList = [];
      list.forEach((t) => {
        permissionList.push({
          showId: t.id,
          showName: t.name,
        });
      });
      this.$http
        .post(this.$apiConfig.set_role_dictionary_permission_url, {
          roleId: this.curRole.roleId,
          list: permissionList,
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.dictionaryDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    fieldTreeDialogClose() {
      this.curRole.roleId = 0;
    },
    indexDialogClose() {
      this.curRole.roleId = 0;
    },
    dictionaryDialogClose() {
      this.curRole.roleId = 0;
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_role_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_role_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    setRolePermission() {
      let permissionIdArr = this.$refs.tree.getCheckedKeys();
      let halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      halfCheckedKeys.forEach((item, index) => {
        permissionIdArr.push(item);
      });
      let formData = new FormData();
      formData.append("roleId", this.curRole.roleId);
      formData.append("userIds", this.curRole.userIds);
      formData.append("permissionIds", permissionIdArr);
      formData.append("oldPermissionIds", this.curRole.oldPermissionIdList);
      this.$http
        .post(this.$apiConfig.set_role_permission_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.curRole.oldPermissionIdList = permissionIdArr;
            this.treeDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    setRoleFieldPermission() {
      let fieldArr = this.$refs.fieldTree.getCheckedNodes();
      let list = [];
      fieldArr.forEach((item, index) => {
        if (!item.hasOwnProperty("children")) {
          list.push({
            fieldId: item.id,
            fieldName: item.name,
          });
        }
      });
      this.$http
        .post(this.$apiConfig.set_role_field_permission_url, {
          roleId: this.curRole.roleId,
          userIds: this.curRole.userIds,
          oldFieldIdList: this.curRole.oldFieldIdList,
          list: list,
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.fieldTreeDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteRole() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let roleIdList = [];
        for (let i = 0; i < len; i++) {
          roleIdList.push(this.selectedList[i].roleId);
        }
        let formData = new FormData();
        formData.append("roleIdList", roleIdList);
        this.$http
          .post(this.$apiConfig.delete_role_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
    closeEditDialog() {},
  },
};
</script>
<style scoped lang="scss">
.dialog-form {
  .el-input {
    width: 400px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-cascader {
    width: 400px;
  }
}
.inputfra {
  width: 400px;
  height: 300px;
  max-height: 50vh;
  .el-checkbox-group {
    margin-left: 10px;
    line-height: 2;
    .el-checkbox {
      display: block;
    }
  }
}
</style>
